import baseApi from "./baseApi"

export default  {
    async getAllowanceTypes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/allowancetypes");
        return result.data;
    },
    async saveAllowanceType(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/allowancetypes", item);
        return result.data;
    }
}